const preventDefaultSubmit = (e) => {
    e.preventDefault();
    alert('Success');
}

export default preventDefaultSubmit;